<template>
	<div>
		<div class="phone_afsc_head">
			<img src="../assets/phone_afsc_icon.jpg" alt="" />
			<img v-show="lang" class="phone_afsc_icon" src="../assets/phone_afsc_icon2.png"/>
			<img v-show="!lang" class="phone_afsc_icon" src="../assets/phone_afsc_icon3.png"/>
		</div>
		<div class="phone_afsc_people">
			<p v-if="lang"><span class="english">AFSC </span>厂牌艺人</p>
	    <p v-else class="english"><span class="english">AFSC </span>Artist</p>
	    <div class="phone_afsc_person">
	    	<div>
	    		<div class="afsc_vio">
            <div id="video_one" class="phone_afsc_vio" v-show="!play_flag">
              <video id="myphone_video_1" class="video-js vjs-default-skin vjs-fluid my_video"  controls preload="auto" width="100%" height="100%" poster="" data-setup="{}">
                <source src="" type='video/mp4'>
                <source src="../assets/person/fl.mp4" type='video/mp4'>
                  您的浏览器版本过低不支持 video 标签。
              </video>
            </div>
            <img class="afsc_img" :style="{display:show}" src="../assets/person/person_1.jpg" alt="">
            <img class="afsc_btn" v-show="play_flag" @click="play_one()" src="../assets/play_btn.png" alt="">
          </div>
    			<div class="person_profile">
    				<p>
    					<span v-if="lang">法老</span>
							<span class="english" v-else>Pharaoh</span>
    				</p>
    				<p>
    					<span v-if="lang">
    						法老来自于上海活死人厂牌<span class="english">HIPHOP</span>歌手，中国著名硬核说唱歌手。现居上海，拥有固定乐迷数十万人，各平台试听量破了千万；作为当今最有实力<span class="english">HIPHOP</span>歌手之一，被誉为“说唱节的诗人”。丰富的舞台表现、舞台视觉与听觉的完美结合，将爆炸的现场，呈现在每一位听众的眼前、耳边；将当代年青人爱拼、爱玩、爱挑战的精神体现的淋漓尽致。
    					</span>
    					<span class="english" v-else>
    						Pharaoh,from the Deadwalking, Shanghai.He is the Chinese famous hardcore rapper, now living in Shanghai. He has more than 100 thousands of fixed fans and his music has more than 10 millions play. As one of the most powerful rapper today, he is known as "Rap Poets". Rich stage performance, the perfect combination of stage vision and hearing, the explosive scene, present for every audience. As the contemporary young people, heincisively and vividly shows the love to challenge, love to play.
    					</span>
    				</p>
    				<p v-if="lang">专辑</p>
    				<p v-else>Album</p>
    				<p><span class="english">ONLY ONE</span></p>
    				<p>如果死亡将要来临</p>
    				<p>日字冲拳<span class="english">(freestyle)</span></p>
    				<p><span class="english">respect</span></p>
    				<p><span class="english">GUCCI GANG REMIX</span></p>
    				<p>独行侠</p>
    			</div>
	    	</div>
	    	<div>
          <div class="afsc_vio">
            <div id="video_two" class="phone_afsc_vio" v-show="!play_flag2">
              <video id="myphone_video_2" class="video-js vjs-default-skin vjs-fluid my_video " controls preload="auto" width="100%" height="100%" poster="" data-setup="{}">
                <source src="" type='video/mp4'>
                <source src="../assets/person/TOY_1.mp4" type='video/mp4'>
                  您的浏览器版本过低不支持 video 标签。
              </video>
            </div>
            <img class="afsc_img" :style="{display:show2}" src="../assets/person/person_2.jpg" alt="">
            <img class="afsc_btn" v-show="play_flag2" @click="play_two()" src="../assets/play_btn.png" alt="">
          </div>
    			<div class="person_profile">
    				<p>
    					<span v-if="lang">
    						<span class="english">TOY</span>
    					</span>
    					<span v-else>
    						<span class="english">TOY_Wong</span>
    					</span>
    				</p>
    				<p>
    					<span v-if="lang">
    						<span class="english">TOY</span>来自于湖南长沙的<span class="english">HIPHOP</span>歌手。现居上海，拥有固定乐迷数十万人，各平台试听量破了千万；作为当今最潜力的<span class="english">HIPHOP</span>歌手，将丰富的舞台表现、舞台视觉与听觉的完美结合，将爆炸的现场，呈现在每一位听众的眼前、耳边；将当代年轻人爱拼、爱玩、爱挑战的精神体现的淋漓尽致。
    					</span>
    					<span class="english" v-else>
    						TOY, a rapper from Changsha, Hunan Province, now lives in Shanghai. He has more than 100 thousand fixed fans and songs have been played 10 millions of times. As the most potential rapper, he combines the rich stage performance, the stage vision and hearing, the explosive scene into his shows. As the contemporary young people, heincisively and vividly shows the love to challenge, love to play
    					</span>
    				</p>
    				<p v-if="lang">专辑</p>
    				<p class="english" v-else>Album</p>
    				<p>那一天</p>
    				<p><span class="english">Comong now</span></p>
    				<p><span class="english">My Birthday</span></p>
    				<p><span class="english">City To City</span></p>
    				<p>路子</p>
    				<p><span class="english">1993</span></p>
    			</div>
    		</div>
    		<div>
    			<div class="afsc_vio">
            <div id="video_three" class="phone_afsc_vio" v-show="!play_flag3">
              <video id="myphone_video_3" class="video-js vjs-default-skin vjs-fluid my_video" controls preload="auto" width="100%" height="100%" poster="" data-setup="{}">
                <source src="" type='video/mp4'>
                <source src="../assets/person/wy.mp4" type='video/mp4'>
                  您的浏览器版本过低不支持 video 标签。
              </video>
            </div>
            <img class="afsc_img" :style="{display:show3}" src="../assets/person/person_3.jpg" alt="">
            <img class="afsc_btn" v-show="play_flag3" @click="play_three()" src="../assets/play_btn.png" alt="">
          </div>
    			<div class="person_profile">
    				<p>
    					<span v-if="lang">王愚</span>
							<span class="english" v-else>
								Pavel
							</span>
    				</p>
    				<p>
    					<span v-if="lang">
    						王愚来自于上海的说唱歌手，同事也是音乐制作人、混音师，现居上海。<span class="english">2016</span>年独立发表个人首张<span class="english">EP</span>《她》在王愚过往发表的作品中，除个别曲目之外，王愚几乎一人担当词曲编曲混音等工作，为华语嘻哈为数不多的全能型音乐创作人之一，被誉为“说唱王羲之”。
    					</span>
    					<span class="english" v-else>
    						Pavel is a rapper from Shanghai. He is also a music producer. In 2016, the first individual EP "she" was released. Except a few pieces, Pavel almost acted as a composer,mixer and producer. He is one of the few all-round artists of Chinese hip-hop, known as “Wang Xizhi of Rap".
    					</span>
    				</p>
    				<p v-if="lang">专辑</p>
    				<p v-else>Album</p>
    				<p>她 <span class="english">Part ll</span></p>
    				<p>他</p>
    				<p><span class="english">Guess What</span></p>
    				<p><span class="english">Merry Christmas</span></p>
    				<p><span class="english">Sensitive:The Pavel Beat Tape</span></p>
    				<p><span class="english">Fresh</span></p>
    			</div>
    		</div>
    		<div>
    			<div class="afsc_vio">
            <div id="video_four" class="phone_afsc_vio" v-show="!play_flag4">
              <video id="myphone_video_4" class="video-js vjs-default-skin vjs-fluid my_video " controls preload="auto" width="100%" height="100%" poster="" data-setup="{}">
                <source src="" type='video/mp4'>
                <source src="../assets/person/LJ.mp4" type='video/mp4'>
                	您的浏览器版本过低不支持 video 标签。
              </video>
            </div>
            <img class="afsc_img" :style="{display:show4}" src="../assets/person/person_4.jpg" alt="">
            <img class="afsc_btn" v-show="play_flag4" @click="play_four()" src="../assets/play_btn.png" alt="">
          </div>
    			<div class="person_profile">
    				<p><span class="english">LIL.JET</span></p>
    				<p>
    					<span v-if="lang">
    						<span class="english">LIL.JET</span> 陆政廷<span class="english">2001</span>年出生，来自广东深圳的<span class="english">HIPHOP/R&B</span>音乐唱作人，从<span class="english">7</span>岁起接触音乐，有丰富的舞台经验接触说唱已有6年时间。现居上海，作为一个00后新锐说唱歌手却拥有超越年龄的磁性声线从歌曲里透露出的放荡不羁只有现场倾听才能感同身受。
    					</span>
    					<span v-else class="english">
    						Lil.Jet was born in 2001,a HIPHOP/R&B artist from Shenzhen, Guangdong. He contacted musicfrom the age of 7, has rich experience in stage. Now he is living in Shanghai. As a young rapper born after 2000, he has a magnetic voicenot like his age.Only at the scene, people can feel his talents.
    					</span>
    				</p>
    				<p v-if="lang">专辑</p>
    				<p v-else>Album</p>
    				<p><span class="english">Venus</span></p>
    				<p>萬聖節</p>
    				<p>说句实话<span class="english">(prod.10k)</span></p>
    				<p>鹰</p>
    				<p><span class="english">JET</span>式病毒</p>
    				<p>自我介绍</p>
    			</div>
    		</div>
    		<div>
    			<div class="afsc_vio">
            <div id="video_five" class="phone_afsc_vio" v-show="!play_flag5">
              <video id="myphone_video_5" class="video-js vjs-default-skin vjs-fluid my_video " controls preload="auto" width="100%" height="100%" poster="" data-setup="{}">
                <source src="" type='video/mp4'>
                <source src="../assets/person/has.mp4" type='video/mp4'>
                  您的浏览器版本过低不支持 video 标签。
              </video>
            </div>
            <img class="afsc_img" :style="{display:show5}" src="../assets/person/person_5.jpg" alt="">
            <img class="afsc_btn" v-show="play_flag5" @click="play_five()" src="../assets/play_btn.png" alt="">
          </div>
    			<div class="person_profile">
    				<p><span class="english">HA$</span></p>
    				<p>
    					<span v-if="lang">
    						<span class="english">HA$</span>来自中国西部新疆的<span class="english">HIPHOP</span>组合，现居上海，来自中国西部新疆，成员都为新疆早期地下知名说唱歌手，<span class="english">2015</span>年首次以团队<span class="english">HA$</span>的名义发布<span class="english">mv</span>《<span class="english">Sow-ghatliq Ketmen</span>》而名声大噪，并以此作品荣获<span class="english">2015</span>年度北京电影学院学院奖短片大赛（原金鸡百花学院奖短片大赛）“观众最喜爱的短片”奖及入围“柏林华语电影节”青年单元提名。一直受热捧的他们今年夏天又以<span class="english">Trap mv</span> 《<span class="english">OYNIMA</span>》红到抽搐！曝光量近百万
    					</span>
    					<span class="english" v-else>
    						HA$is a rap team from Xinjiang in Western China, now living in Shanghai. members are the early well-known underground rapper in Xinjiang. In 2015, they released MV "Sowghatliq Ketmen" and got much attention. They won the 2015 Beijing Film University Awards and were nominated by the youth unit of the Berlin Chinese Film Festival. As an always popular rap team, they were foucused again by the Trap mv“OYNIMA”, getting almost 1 million views.
    					</span>
    				</p>
    				<p v-if="lang">专辑</p>
    				<p v-else>Album</p>
    				<p><span class="english">Versace On Da Floor</span></p>
    				<p><span class="english">H.G.O.D.W</span></p>
    				<p>定时闹钟</p>
    				<p>很高兴见到你</p>
    				<p><span class="english">One</span></p>
    			</div>
    		</div>
	    </div>
		</div>
		<div id="person_1" class="phone_afsc_person_1">
			<p v-if="lang"><span class="english">AFSC 2017</span>全国巡演回顾</p>
			<p v-else class="english">AFSC 2017 China tour review</p>
			<div v-show="lang" class="afsc_main">
	      <div>
	        <iframe frameborder="0" src="https://v.qq.com/iframe/player.html?vid=o0534a31239&tiny=0&auto=0" allowfullscreen></iframe>
	      </div>
			</div>
	    <div v-show="!lang" class="afsc_main">
	      <div><iframe src="https://www.youtube.com/embed/GEcz4jm0fhU" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>
	    </div>
    </div>
		<div class="phone_afsc_person_2">
			<p v-if="lang">派嗨拜浪 ( 上海 ) 网络科技有限公司版权所有<br />©2016【 沪ICP备16032276号 】</p>
	    <p v-else class="english">PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD. All rights reserved<br />©2016[Shanghai ICP no. 16032276]</p>
	    <p v-if="lang">本网站由派嗨拜浪 ( 上海 ) 网络科技有限公司提供</p>
	    <p v-else class="english">This website is provided by PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD</p>
		</div>
	</div>
</template>

<script>
	
	import videojs from 'video.js'
	import 'video.js/dist/video-js.css'
	
	export default {
	  name: 'HelloWorld',
  	props:["lang"],
	  data () {
	    return {
	      msg: '11',
	      video_one: '',
	      play_flag: true,
	      show: 'inline-block',
	      video_two: '',
	      play_flag2: true,
	      show2: 'inline-block',
	      video_three: '',
	      play_flag3: true,
	      show3: 'inline-block',
	      video_four: '',
	      play_flag4: true,
	      show4: 'inline-block',
	      video_five: '',
	      play_flag5: true,
	      show5: 'inline-block',
	      phone_flag: ''
	    }
	  },
	  methods: {
	    play_one () {
	    	console.log(this.IsPC());
	      this.video_one.play();
	    	if (this.IsPC()) {
	    		this.play_flag = false
	    	}
	    },
	    play_two () {
	      this.video_two.play();
	      if (this.IsPC()) {
	    		this.play_flag2 = false
	    	}
	    },
	    play_three () {
	      this.video_three.play()
	      if (this.IsPC()) {
	    		this.play_flag3 = false
	    		console.log(1);
	    	}
	    },
	    play_four () {
	      this.video_four.play()
	      if (this.IsPC()) {
	    		this.play_flag4 = false
	    	}
	    },
	    play_five () {
	      this.video_five.play()
	      if (this.IsPC()) {
	    		this.play_flag5 = false
	    	}
	    },
	    IsPC () {
	      var userAgentInfo = navigator.userAgent;
	      var Agents = ["iPhone","Windows Phone"];
	      var flag = true;
	      for (var v = 0; v < Agents.length; v++) {
	        if (userAgentInfo.indexOf(Agents[v]) > 0) {
	          flag = false;
	          break;
	        }
	      }
	      return flag;
	    }
	  },
	  mounted () {
	  	if(document.getElementById('phoneafsc_icon')) {
	  		document.getElementById('phoneayo_icon').style.display = "inline-block";
		    document.getElementById('phoneayo_icon_2').style.display = "none";
		    document.getElementById('phoneafsc_icon').style.display = "none";
		    document.getElementById('phoneafsc_icon_2').style.display = "inline-block";
	  	}else{
	  		setTimeout(() => {
          document.getElementById('phoneayo_icon').style.display = "inline-block";
			    document.getElementById('phoneayo_icon_2').style.display = "none";
			    document.getElementById('phoneafsc_icon').style.display = "none";
			    document.getElementById('phoneafsc_icon_2').style.display = "inline-block";
        },1);
	  	}
	  	
	    
	    this.video_one = videojs(document.getElementById('myphone_video_1'))
	    this.video_two = videojs(document.getElementById('myphone_video_2'))
	    this.video_three = videojs(document.getElementById('myphone_video_3'))
	    this.video_four = videojs(document.getElementById('myphone_video_4'))
	    this.video_five = videojs(document.getElementById('myphone_video_5'))
	  }
	}
</script>

<style lang="less" scoped>
	.phone_afsc_head {
		height: 26rem;
		background-color: #000000;
		padding-top: 9rem;
		position: relative;
		img {
			width: 80%;
		}
	}
	
	.phone_afsc_icon {
		position: absolute;
		left: 10%;
	}
	
	.my_video {
		position: absolute;
		width: 100%;
		height: 100%;
		border: .5rem solid #FFFC01;
	}
	
	.phone_afsc_person {
		width: 100%;
		&>div {
			width: 100%;
		}
	}
	
	.phone_afsc_people {
		background-color: #000000;
		&>p {
			color: #FFFB00;
			padding-top: 3rem;
			margin: 0;
			padding-bottom: 3rem;
			font-family: Heavy;
			font-size: 1.6rem;
			text-align: center;
			letter-spacing: 0.1rem;
			font-weight: bold;
		}
	}
	
	.phone_afsc_vio {
		/*display: block;*/
	}
	
	.afsc_vio {
		width: 70%;
		position: relative;
		margin: 0 auto;
		.afsc_img {
			width: 100%;
		}
		.afsc_btn {
			width: 15%;
			position: absolute;
			left: 1.5rem;
			bottom: 1.5rem;
		}
	}
	
	.person_profile {
		width: 70%;
		margin: 0 auto;
		padding-bottom: 6rem;
		p {
			margin: 0;
			color: #FFFB00;
			text-align: left;
		}
		p:nth-child(1) {
			font-size: 2.2rem;
			font-family: Heavy;
			font-weight: bold;
			margin: .7rem 0 .7rem 0;
		}
		p:nth-child(2) {
			font-size: 1rem;
			line-height: 1.5rem;
			font-family: Regular;
			text-align:justify;
			letter-spacing: .07rem;
		}
		p:nth-child(3) {
			margin: .7rem 0 .5rem 0;
			font-size: 1.6rem;
			font-family: Heavy;
			text-align: left;
			font-weight: bold;
		}
		p:nth-child(n+4) {
			font-size: 1rem;
			font-family: Regular;
			text-align:justify;
			letter-spacing: .07rem;
			margin: .5rem 0 .5rem 0;
		}
		.english {
			letter-spacing: 0.01rem;
		}
	}
	
	.phone_afsc_person_1 {
		background-color: #FFFB00;
		&>p {
			color: #000000;
			padding-top: 3rem;
			margin: 0;
			padding-bottom: 1rem;
			font-family: Heavy;
			font-size: 1.6rem;
			text-align: center;
			font-weight: bold;
		}
		iframe {
			width: 17rem;
			border: .5rem solid #FFFC01;
		}
	}
	
	.phone_afsc_person_2 {
		width: 100%;
		margin: 0 auto;
		background-color: #FFFB00;
		padding: 6rem 0rem 2rem 0rem;
		p {	
			width: 96%;
			margin: 0 auto;
			color: #000000;
			font-family: Regular;
			font-size: .8rem;
			text-align: center;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/phone_afsc.vue